// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"e7cacb40","942":"2bbbce3d"}[chunkId] + ".chunk.js";
};